import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { JOURNEY_EDIT_ERROR } from '~/types/Journey.types';
const useJourneyEditErrorMessage = () => {
  const $ = _c(2);
  const t = useTranslations("journey");
  let t0;
  if ($[0] !== t) {
    t0 = error => {
      switch (error) {
        case "ACCOMMODATION_UNAVAILABLE":
          {
            return t("edit_error_accommodation_unavailable");
          }
        case "REPLANNED_DUE_TO_MODIFY_FAILURE":
          {
            return t("edit_error_replanned");
          }
        case "TRANSPORT_UNAVAILABLE":
          {
            return t("edit_error_transport_unavailable");
          }
        case "UNKNOWN_FAILURE":
          {
            return "";
          }
      }
    };
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export { useJourneyEditErrorMessage };